
import {api} from "../../config/api";
import {createAsyncThunk} from "@reduxjs/toolkit";

export const getBasicInfoAllTracks = createAsyncThunk(
    "playlist/getBasicInfoAllTracks",
    async ({ token, page = 1, limit = 50 }) => {
        const response = await api.get("/playlist/basic",
        {
            token: token,
            params: {

                page,
                limit,
            },
        },
    );
        console.log(response.data)
        return response.data;
    }
);

export const searchPlaylistTracks = createAsyncThunk(
    "playlist/searchPlaylistTracks",
    async ({ token, search, page = 1, limit = 50 }) => {    
        const response = await api.get("/playlist/search",
        {
            token: token,
            params: {
                search,
                page,       
                limit,
            },
        });
        console.log(response.data)
        return response.data;
    }
);

export const getBasicInfoAllTracks1 = createAsyncThunk(
    "playlist/getBasicInfoAllTracks1",
    async (token) => {
        const response = await api.get("/playlist/basic/track",
        {
            token: token,
        });
        console.log(response.data)
        return response.data;
    }
);

export const getAllPlaylists = createAsyncThunk(
    "playlist/getAllPlaylists",
    async ({ token , page = 1, limit = 50, search }) => {
        const response = await api.get("/playlist/all-playlist/table",
            {
                token: token,
                params: {
                    page,
                    limit,
                    search,
                },
            });
        console.log(response.data)
        return response.data;
    }
);
export const deletePlaylist = createAsyncThunk('track/deletePlaylist', async ({ token, id }) => {
    const response = await api.delete(
        `/playlist/${id}`,
        {
            token: token,
        },
    );
    return response.data.data;
});

export const updatePlaylist = createAsyncThunk('playlist/createAndUpdatePlaylist', async ({ payload, id }) => {
    const response = await api.put(
        `/playlist/${id}`,
        { payload },
    );
    return response.data;
});

export const createPlaylist = createAsyncThunk('playlist/createAndUpdatePlaylist', async ({ payload, id }) => {
    const response = await api.post(
        '/playlist',
        { payload },
    );
    return response.data;
})


export const getPlaylistById = createAsyncThunk('playlist/getPlaylistById', async ({ id, token }) => {
    const response = await api.get(
        `/playlist/${id}`,
    );
    return response.data;
});